import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { FAQ, HOME_FAQ_IDS } from "../data/faq";

// Three answers, one next step (D2.2): the cards carry no individual CTAs.
export const FaqCallout = () => {
  const items = HOME_FAQ_IDS.map((id) => FAQ.find((f) => f.id === id)).filter(Boolean);
  return (
    <section className="pb-24 md:pb-32 max-w-7xl mx-auto px-6 lg:px-10" data-testid="home-faq">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-8">
          <div>
            <p className="label text-sage mb-3">Before you ask</p>
            <h2 className="font-serif text-3xl md:text-5xl text-navy-deep leading-tight">The three questions everyone asks first.</h2>
          </div>
          <Link to="/faq" data-testid="home-faq-all" className="inline-flex items-center gap-2 text-sm font-semibold text-navy hover:gap-3 transition-all shrink-0">
            All questions <ArrowUpRight size={16} />
          </Link>
        </div>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-4">
        {items.map((f, i) => (
          <Reveal key={f.id} delay={i * 0.08}>
            <div className="h-full rounded-2xl bg-white border border-navy/10 p-7" data-testid={`home-faq-${f.id}`}>
              <h3 className="font-serif text-xl md:text-2xl text-navy-deep leading-snug">{f.q}</h3>
              <p className="mt-3 text-navy-deep/70 leading-relaxed">{f.a}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
